import React from 'react';
import { SolutionTemplate } from '../../components/SolutionTemplate';

export const ResidentialSolar = () => {
  const benefits = [
    {
      title: 'Slash Electricity Bills',
      description: 'Reduce your monthly power bills by up to 80%. Typical payback period of 3-5 years.'
    },
    {
      title: 'Increase Property Value',
      description: 'Homes with solar panels sell faster and at premium prices. A smart long-term investment.'
    },
    {
      title: 'Government Subsidies',
      description: 'Get up to ₹78,000 in subsidies under PM Surya Ghar scheme for residential installations.'
    },
    {
      title: 'Zero Maintenance',
      description: 'Solar panels require minimal maintenance. Just occasional cleaning for optimal performance.'
    },
    {
      title: 'Energy Independence',
      description: 'Protect yourself from rising electricity tariffs. Generate your own clean power.'
    },
    {
      title: 'Environmental Impact',
      description: 'A 3kW system offsets 4+ tons of CO2 annually. Equivalent to planting 180 trees.'
    }
  ];

  const features = [
    {
      title: 'Premium Tier-1 Solar Panels',
      description: '25-year performance warranty with 80%+ efficiency guarantee'
    },
    {
      title: 'Advanced String Inverter',
      description: '5-year warranty, MPPT technology for maximum power output'
    },
    {
      title: 'Heavy-Duty Mounting Structure',
      description: 'Rust-proof aluminum/galvanized steel, wind-resistant design'
    },
    {
      title: 'Complete Installation',
      description: 'Professional installation with minimal roof penetration'
    },
    {
      title: 'Net Metering Setup',
      description: 'Full support for DISCOM approvals and bi-directional meter installation'
    },
    {
      title: 'Remote Monitoring App',
      description: 'Track generation, consumption, and savings in real-time'
    }
  ];

  const faqs = [
    {
      question: 'What size solar system do I need for my home?',
      answer: 'It depends on your monthly electricity consumption. For a typical Indian household consuming 300-400 units/month, a 3-5 kW system is ideal. Our experts will conduct a free site survey to recommend the optimal size.'
    },
    {
      question: 'How much does a residential solar system cost?',
      answer: 'After government subsidies, a 3kW system costs around ₹1.5-2 lakhs, while a 5kW system costs ₹2.5-3 lakhs. We offer flexible EMI options starting at ₹5,000/month with zero down payment.'
    },
    {
      question: 'Will solar panels work during power cuts?',
      answer: 'Standard on-grid systems automatically shut down during power cuts for safety reasons. If you need backup power, we recommend a hybrid system with battery storage.'
    },
    {
      question: 'How long does installation take?',
      answer: 'Physical installation takes 2-3 days. Including DISCOM approvals and net metering setup, the entire process is completed within 4-6 weeks.'
    },
    {
      question: 'What maintenance is required?',
      answer: 'Very minimal. Clean panels with water every 2-3 months (more frequently if you live near dusty areas). We provide annual maintenance checks as part of our warranty.'
    },
    {
      question: 'Can I install solar on a rented property?',
      answer: 'Yes, with written permission from the property owner. Many landlords are supportive as solar increases property value and attracts quality tenants.'
    }
  ];

  return (
    <SolutionTemplate
      title="Residential Solar Solutions"
      description="Perfect for homeowners, villas, and independent houses. Cut your electricity bills by up to 80% while increasing your property value."
      heroImage="https://images.unsplash.com/photo-1761472823286-9f6093ed6663?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxzb2xhciUyMHBhbmVscyUyMG1vZGVybiUyMGhvdXNlJTIwcm9vZiUyMGJsdWUlMjBza3l8ZW58MHx8fHwxNjczMzQ0MjR8MA&ixlib=rb-4.1.0&q=85"
      benefits={benefits}
      features={features}
      faqs={faqs}
      testId="residential-solar"
    />
  );
};